import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import Index from "./pages/Index";
import MalePartnerCalculator from "./pages/MalePartnerCalculator";
import IdealWomanCalculator from "./pages/IdealWomanCalculator";
import DatingStandardsCalculator from "./pages/DatingStandardsCalculator";
import FAQ from "./pages/FAQ";
import Methodology from "./pages/Methodology";
import DataSources from "./pages/DataSources";
import Glossary from "./pages/Glossary";
import Sitemap from "./pages/Sitemap";
import StatsHub from "./pages/StatsHub";
import StatsArticlePage from "./pages/StatsArticlePage";
import StatesHub from "./pages/StatesHub";
import StatePage from "./pages/StatePage";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import About from "./pages/About";
import NotFound from "./pages/NotFound";
import ScrollToTop from "./components/ScrollToTop";
import AnalyticsTracker from "./components/AnalyticsTracker";
import ConsentBanner from "./components/ConsentBanner";

const queryClient = new QueryClient();

// Router is provided by the entry point: BrowserRouter in main.tsx,
// StaticRouter in entry-server.tsx (build-time prerendering).
const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange={false}
    >
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <ScrollToTop />
        <AnalyticsTracker />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/male-partner-calculator" element={<MalePartnerCalculator />} />
          <Route path="/ideal-woman-calculator" element={<IdealWomanCalculator />} />
          <Route path="/dating-standards-calculator" element={<DatingStandardsCalculator />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/methodology" element={<Methodology />} />
          <Route path="/data-sources" element={<DataSources />} />
          <Route path="/glossary" element={<Glossary />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/stats" element={<StatsHub />} />
          <Route path="/stats/:slug" element={<StatsArticlePage />} />
          <Route path="/states" element={<StatesHub />} />
          <Route path="/states/:slug" element={<StatePage />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/about" element={<About />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        <ConsentBanner />
      </TooltipProvider>
    </ThemeProvider>
  </QueryClientProvider>
);

export default App;
